module.exports = __webpack_public_path__ + "static/media/VestasSans-Book.9404247f.svg";